export default __webpack_public_path__ + "static/media/ico-elastic-cache-score-low.f6e1680b.svg";